import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { FAQS } from "@/data";

export default function FAQ() {
  return (
    <section id="faq" className="py-24 sm:py-32 scroll-mt-20 bg-card border-y border-border">
      <div className="mx-auto max-w-3xl px-5 sm:px-8">
        <div className="mb-12 text-center">
          <span className="text-accent font-bold text-sm tracking-widest uppercase">FAQ</span>
          <h2 className="font-display font-extrabold text-4xl sm:text-6xl mt-3 tracking-tight text-primary">
            Your questions, answered!
          </h2>
        </div>

        <Accordion type="single" collapsible className="w-full">
          {FAQS.map((f, i) => (
            <AccordionItem
              key={i}
              value={`item-${i}`}
              data-testid={`faq-accordion-${i}`}
              className="border-b border-border"
            >
              <AccordionTrigger className="text-left font-display font-extrabold text-[1.8rem] leading-tight text-primary hover:text-accent hover:no-underline py-6">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-muted-foreground text-lg leading-relaxed pb-6 font-medium [&_a]:text-accent [&_a]:font-bold [&_a]:underline [&_a]:underline-offset-2 hover:[&_a]:text-primary">
                <span dangerouslySetInnerHTML={{ __html: f.a }} />
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
}
